// extracted by mini-css-extract-plugin
module.exports = {"container":"x_e","containerMargins":"x_y"};